import React from 'react';
import { Typography } from '@mui/material';
import { Row } from 'components/Layout';

type LabelValueRowProps = {
  label: string;
  spacing?: 'sm' | 'md' | 'lg';
  children?: React.ReactNode;
};

const LabelValueRow: React.FC<LabelValueRowProps> = ({
  label,
  spacing = 'lg',
  children,
}) => (
  <Row spacing={spacing} justify="space-between">
    {label}
    <Typography variant="body2" fontWeight="bold">
      {children ?? '-'}
    </Typography>
  </Row>
);

export default LabelValueRow;
